import { Button, Grid, MenuItem } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { isEqual } from 'lodash'
import { memo } from 'react'
import { metodoPrograma } from '../../../components/api'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'
import DateField from '../../../components/DateField/DateField'
import dayjs from 'dayjs'
import { listaSituacao } from '.'
import * as Yup from 'yup'
import CurrencyField from '../../../components/CurrencyField/CurrencyField'

const validationFormik = Yup.object({
  dsTitulo: Yup.string().required('Campo Obrigatório!'),
  dsSolicitacao: Yup.string().required('Campo Obrigatório!'),
  tpSituacao: Yup.string().required('Campo Obrigatório!'),
  dtInicio: Yup.date().required('Campo Obrigatório!'),
})

const retornaLocalAtendimento = (u = []) => ({
  idManutencao: u?.[0] || null,
  dsTitulo: u?.[1] || null,
  dsSolicitacao: u?.[2] || null,
  tpSituacao: u?.[3] || null,
  acEquipamento: u?.[5] || null,
  vlOrcamento: u?.[6] || null,
  dtInicio: u?.[7] ? dayjs(u?.[7]) : undefined,
  dtConclusao: u?.[8] ? dayjs(u?.[8]) : undefined,
  dsConclusao: u?.[9] || null,
  dsPrestadorServico: u?.[11] || null,
})

const Edicao = ({ dados, voltar }) => {
  const salva = async (values) => {
    const payload = {
      ...values,
      dtInicio: values?.dtInicio
        ? dayjs(values.dtInicio).format('YYYY-MM-DD HH:mm:ss')
        : undefined,
      dtConclusao: values?.dtConclusao
        ? dayjs(values.dtConclusao).format('YYYY-MM-DD HH:mm:ss')
        : undefined,
      idEquipamento: values.acEquipamento?.[0]?.[0],
    }

    const res = await metodoPrograma('salva', payload)
    if (res.status) voltar()
  }

  return (
    <Formik
      initialValues={retornaLocalAtendimento(dados)}
      validationSchema={validationFormik}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm, values, setFieldValue, getFieldMeta }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Field
                component={TextField}
                name="dsTitulo"
                label="Titulo"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                component={TextField}
                name="dsSolicitacao"
                label="Solicitação"
                minRows={3}
                multiline
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                component={TextField}
                name="dsPrestadorServico"
                label="Nome do Prestador de Serviços"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={12}>
              <AutoComplete
                InputLabelProps={{ shrink: true }}
                label="Equipamento"
                name="acEquipamento"
                metodo="buscaEquipamento"
                value={values.acEquipamento}
                textFieldProps={{
                  error: getFieldMeta('acEquipamento').error,
                  helperText: getFieldMeta('acEquipamento').error,
                }}
                onChange={(_, v) => {
                  setFieldValue('acEquipamento', v)
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <DateField
                name="dtInicio"
                fullWidth
                label="Previsão Início"
                value={values?.dtInicio || null}
                onChange={(v) => setFieldValue('dtInicio', v)}
                slotProps={{
                  textField: {
                    error: getFieldMeta('dtInicio').error,
                    helperText: getFieldMeta('dtInicio').error,
                  },
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="tpSituacao"
                label="Status"
                fullWidth
                margin="dense"
                select
                variant="outlined"
                size="small"
              >
                {listaSituacao.map((v, idx) => (
                  <MenuItem key={idx} value={v[0]}>
                    {v[1]}
                  </MenuItem>
                ))}
              </Field>
            </Grid>
            <Grid item xs={3}>
              <CurrencyField
                value={values?.vlOrcamento}
                fullWidth
                variant="outlined"
                margin="dense"
                label="Valor do Orçamento"
                size="small"
                onChange={(v) => {
                  setFieldValue('vlOrcamento', v)
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={DateField}
                name="dtConclusao"
                fullWidth
                label="Dt. Conclusão"
                value={values?.dtConclusao || null}
                onChange={(v) => setFieldValue('dtConclusao', v)}
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                component={TextField}
                name="dsConclusao"
                label="Parecer de Conclusão"
                minRows={3}
                multiline
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>

            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default memo(Edicao, isEqual)
